var React = require('react');

function IconWindow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Application Window"),React.createElement("g",{"fill":"currentColor","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M3.667 1.833c-1.013 0-1.834.821-1.834 1.834v14.666c0 1.013.821 1.834 1.834 1.834h14.666c1.013 0 1.834-.821 1.834-1.834V3.667c0-1.013-.821-1.834-1.834-1.834H3.667zm0-1.833h14.666A3.667 3.667 0 0 1 22 3.667v14.666A3.667 3.667 0 0 1 18.333 22H3.667A3.667 3.667 0 0 1 0 18.333V3.667A3.667 3.667 0 0 1 3.667 0z","fillRule":"nonzero","key":0}),React.createElement("path",{"d":"M0 8h22v1.905H0z","key":1}),React.createElement("circle",{"cx":"5","cy":"5","r":"1","key":2}),React.createElement("circle",{"cx":"8","cy":"5","r":"1","key":3}),React.createElement("circle",{"cx":"11","cy":"5","r":"1","key":4})])]);
}

IconWindow.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = IconWindow;

IconWindow.default = IconWindow;
